import axios from 'axios'
import alert from '@/utils/alert'
import { KEYS, getItem } from '@/store/localStorage'
import store from '@/store'
import messages from '@/constants/messages'
import moment from 'moment'

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSBLE_ENTITY: 422,
  SERVICE_UNAVAILABLE: 503,
}

const PATHS_IGNORE_ERROR = ['/profile/picture'];

export const getHorario = () => {
  return `<br /><span style="font-size: 0.8rem; color: #696969;">${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</span>`
}

const showLoading = () => {
  store.commit('loader/SET_LOADER')
}

const hideLoading = () => {
  store.commit('loader/RESET_LOADER')
}

const addRequestInterceptor = (instance) => {
  instance.interceptors.request.use(config => {
    showLoading()
    return config
  },
  error => {
    hideLoading()
    return Promise.reject(error)
  })
}

const addResponseInterceptor = (instance) => {
  instance.interceptors.response.use(function (response) {
    hideLoading()
    return response.data
  }, function (error) {
    hideLoading()
    if (!error.response) {
      alert.error({
        title: 'Erro!',
        msg: `${messages.ERROR_MESSAGE} ${getHorario()}`,
      })
      return Promise.reject(error)
    }

    if (
      PATHS_IGNORE_ERROR.includes(error.response.config.url) &&
      (error.response.status === HTTP_STATUS.SERVICE_UNAVAILABLE ||
        error.response.status === HTTP_STATUS.NOT_FOUND)
    ) {
      return Promise.resolve();
    }

    const { status, data, statusText } = error.response
    const { message } = data

    if (status === HTTP_STATUS.UNAUTHORIZED) {
      alert.error({
        title: 'Sua sessão expirou!',
        msg: `Faça o login novamente. ${getHorario()}`,
      })
      return Promise.reject(error)
    }

    if (status === HTTP_STATUS.NOT_FOUND) {
      alert.error({
        title: 'Erro!',
        msg: `${messages.ERROR_MESSAGE} ${getHorario()}`,
      })
      return Promise.reject(error)
    }

    alert.error({
      title: statusText || 'Erro!',
      msg: `${message || messages.ERROR_MESSAGE} ${getHorario()}`,
    })

    return Promise.reject(error)
  })
}

export default (baseURL = process.env.VUE_APP_ROOT_URL) => {
  const instance = axios.create({
    baseURL,
  })

  instance.defaults.headers.common['Authorization'] = getItem(KEYS.LOGIN.jwt)
  addRequestInterceptor(instance)
  addResponseInterceptor(instance)

  return instance
}
